import { render, staticRenderFns } from "./CharacterSelector.vue?vue&type=template&id=256b8212&scoped=true"
import script from "./CharacterSelector.vue?vue&type=script&lang=js"
export * from "./CharacterSelector.vue?vue&type=script&lang=js"
import style0 from "./CharacterSelector.vue?vue&type=style&index=0&id=256b8212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b8212",
  null
  
)

export default component.exports